<template>
  <!-- 历史数据 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{
                  item.tenantName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分区选择">
              <a-tree-select
                :tree-data="zoneTreeData"
                v-model="query.zoneId"
                style="width: 100%"
                :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                placeholder="请选择片区"
                allow-clear
                tree-default-expand-all
              ></a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用户编号">
              <a-input v-model="query.appearanceNo" placeholder="请输入用户编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用户名称">
              <a-input v-model="query.username" placeholder="请输入用户名称,支持模糊查询" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="电话号码">
              <a-input v-model="query.telephone" placeholder="请输入电话号码,支持模糊查询" allow-clear />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="48">
          <a-col :md="8" :sm="12">
            <a-form-item label="采集时间">
              <a-range-picker
                format="YYYY-MM-DD"
                :placeholder="['推送开始时间', '推送结束时间']"
                @change="pushOnChange"
                v-model="pushTime"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="厂商">
              <a-input v-model="query.firm" placeholder="请输入厂商,支持模糊查询" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <a-button
                type="primary"
                style="margin-left: 8px"
                :loading="exportLoading"
                @click="exportHandle()"
                v-action:export
                >导出</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      bordered
      :scroll="{ x: 2100 }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="createTime" slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
      <span slot="installDate" slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
      <span slot="collectTime" slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
    </a-table>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import { getPipeLineMaterialOptions, getPipeDiameterSizeOptions } from '@/api/manage'
const columns = [
  {
    title: '用户编号',
    dataIndex: 'appearanceNo',
  },
  {
    title: '区域名称',
    dataIndex: 'zoneName',
  },
  {
    title: '厂商',
    dataIndex: 'firm',
  },
  {
    title: '用户姓名',
    dataIndex: 'userNikeName',
    ellipsis: true,
  },
  {
    title: '安装地址',
    dataIndex: 'address',
    ellipsis: true,
  },
  {
    title: '手机号',
    dataIndex: 'telephone',
  },
  {
    title: '安装日期',
    dataIndex: 'installDate',
    scopedSlots: { customRender: 'installDate' },
  },
  {
    title: '水表读数',
    dataIndex: 'meterNumber',
  },
  {
    title: '信号强度',
    dataIndex: 'signalStrength',
  },
  {
    title: '采集时间',
    dataIndex: 'collectTime',
    scopedSlots: { customRender: 'collectTime' },
  },
  {
    title: '获取时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' },
  },
]

export default {
  mixins: [mixinViewModule],
  name: 'UserRemoteWaterDataList',
  data() {
    return {
      currentId: '',
      queryUrl: '/pipe-network/yc_user_remote_water_meters/data/page',
      deleteUrl: '/pipe-network/yc_user_remote_water_meters/data',
      queryOneUrl: '/pipe-network/yc_user_remote_water_meters/data',
      exportDataUrl: 'pipe-network/yc_user_remote_water_meters/data/export',
      exportFileName: '贸易结算表历史数据.xlsx',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      zoneTreeData: [], // 片区选项
      pushTime: [],
      query: {
        zoneId: undefined,
        telephone: '',
        username: '',
        appearanceNo: '',
        collectTimeStart: '',
        collectTimeEnd: '',
        tenantId: this.$store.state.user.info.tenantId,
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
    }
  },
  filters: {
    permissionFilter(key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    },
  },
  created() {
    this.getAllTenant()
    this.getZoneData()
  },
  methods: {
    handleCancel() {},
    getZoneData() {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    // 重置
    resetList() {
      this.pushTime = []
      this.selectedRows = []
      this.query = {}
      this.pagination.current = 1
      this.queryList()
      console.log(this.pushTime)
    },
    pushOnChange(value, dateString) {
      this.query.collectTimeStart = dateString[0] + ' 00:00:00'
      this.query.collectTimeEnd = dateString[1] + ' 00:00:00'
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
